import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { map } from 'rxjs/operators';
import { AppState } from '../../app.state';
import { Route, RoutingHelperService } from '../services/routing-helper.service';

/**
 * Fecha a etapa de Contrato para o modo vendedor.
 *
 * Quem assina é o titular, na tela de pagamento dele — nunca o vendedor, que
 * só recebe um link para repassar. Sem esta guarda, digitar `/contrato` na
 * barra de endereço (a navegação normal já pula esta etapa) colocaria o
 * vendedor diante do documento de outra pessoa, com o iframe pronto para
 * assinatura.
 */
export const notSellerModeGuard: CanActivateFn = () => {
  const store = inject(Store);
  const router = inject(Router);
  const routingService = inject(RoutingHelperService);

  return store.select(AppState.isSellerMode).pipe(
    map((isSellerMode) => {
      if (!isSellerMode) {
        return true;
      }

      router.navigate([routingService.getRelativePath(Route.Payment.path)]);
      return false;
    }),
  );
};
